// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BaseAssessmentStep_wrapper__y0NWj","label":"BaseAssessmentStep_label__hMOrq","active":"BaseAssessmentStep_active__17JPC"};